var path = '/glow/component/glow-module/module-ugc/component/ugc-modal/tpl/ugc-modal-cta.html';
var html = "<div class=glow-ugc> <div ng-if=\"$ctrl.displayForm === 'modal'\" class=\"glow-ugc-wrapper text-center\" ng-style=$ctrl.styles.wrapper> <a href=# ng-click=\"$ctrl.launchGlowUgc($ctrl.moduleId, false)\"> <img class=cta-image ng-src={{image}} alt={{$ctrl.backgroundAltText}} /> </a> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/glow/component/glow-module/module-ugc/component/ugc-modal/tpl/ugc-modal-cta.html
// module id = 1758
// module chunks = 1